<template>
    <div class="card card-height">
        <div class="table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th>Treatment Name</th>
                        <th>Schedule Date</th>
                        <th>Completed Date</th>
                        <th>Consultant / Doctor</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in serviceList" :key="i">
                        <td>{{ item.product_name }}</td>
                        <td>{{ item.scheduled_date }}</td>
                        <td></td>
                        <td>{{ item.contact_name }}</td>
                        <td>{{ convertToTitleCase(item.status) }}</td>
                        <td v-if="currentHasTab === 'completed_service'">
                            <button @click="onClickToCreatePrescription(item)" class="btn btn-secondary btn-sm">
                                <i class="fas fa-eye"></i>
                                View Prescription
                            </button>
                        </td>
                        <td v-else>
                            <button @click="onClickToCreatePrescription(item)" v-if="item.prescription_count < 1" class="btn btn-secondary btn-sm">
                                <i class="fas fa-plus"></i>
                                Create Prescription
                            </button>
                            <button @click="onClickToCreatePrescription(item)" v-else class="btn btn-secondary btn-sm">
                                <i class="fas fa-eye"></i>
                                View Prescription
                            </button>
                        </td>
                    </tr>

                </tbody>
            </table>
            <p v-if="!serviceList.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import {useRoute, useRouter} from "vue-router";
import { convertToTitleCase } from '@/services/utils/global';
import { computed } from "vue";

const props = defineProps({
    serviceList: Array
})

const route = useRoute();
const router = useRouter();

const currentHasTab = computed(() => route.hash ? route.hash.substring(1) : '')

const onClickToCreatePrescription = (item) => {
    router.push({
        name: 'dental-service',
        params: {
            ...route.params,
            serviceId: item.service_general_id
        },
        query: {
            ...route.query,
            general_id: item.id,
            ipd_register_id: item.ipd_register_id,
            contact_id: item.contact_profile_id,
            service_status: currentHasTab.value
        }
    })
}
</script>
<style scoped>
.card--height {
  min-height: 200px
}
</style>
